import Service from '@ember/service';

import window from 'ember-window-mock';

import {
  CONSENT_IS_REQUIRED_VENDORS,
  TECHNICAL_VENDORS,
} from 'register-partners-js/constants/cookie-vendors';

const ALL_INTEGRATIONS_KEY = 'All';
const ALL_INTEGRATIONS_DEFAULT_VALUE = true;

export default class CookiesConsentManager extends Service {
  shouldConsentBeCollected() {
    return window.Didomi?.shouldConsentBeCollected?.() ?? true;
  }

  getSegmentIntegrations() {
    return {
      [ALL_INTEGRATIONS_KEY]: ALL_INTEGRATIONS_DEFAULT_VALUE,
      ...this.getCookieConsentForTechnicalVendors(),
      ...this.getCookieConsentForNonEssentialVendors(),
    };
  }

  getCookieConsentForTechnicalVendors() {
    return Object.values(TECHNICAL_VENDORS).reduce((acc, vendor) => {
      acc[vendor.name] = true;
      return acc;
    }, {});
  }

  getCookieConsentForNonEssentialVendors() {
    return Object.values(CONSENT_IS_REQUIRED_VENDORS).reduce((acc, vendor) => {
      acc[vendor.name] = this.hasCookieConsentForVendor(vendor);
      return acc;
    }, {});
  }

  hasCookieConsentForVendor({ id }) {
    return window.Didomi?.getUserConsentStatusForVendor?.(id) ?? false;
  }
}
